<template>
  <div>
    <v-chip :class="color" :small="small">
      {{
        $t(status, {
          billing_end_date: formatDate(this.product.billing_end_date),
        })
      }}
    </v-chip>
    <v-chip
      class="deep-orange grey--text text--lighten-2 my-1 mr-1"
      :small="small"
      v-if="blocked"
    >
      {{ $t("blocked") }}
      <v-icon small right class="grey--text text--lighten-2">
        mdi-power-plug-off
      </v-icon>
    </v-chip>
  </div>
</template>

<script>
import ProductTools from "@/utils/mixins/productTools";
import formatDate from "@/utils/mixins/formatDate";

export default {
  name: "ProductStatus",
  mixins: [ProductTools, formatDate],
  props: {
    product: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    now: null,
  }),
  watch: {
    product: {
      immediate: true,
      handler(value) {
        this.now = new Date();
      },
    },
  },
  computed: {
    status() {
      // setup (unique)
      if (["ER", "WHO-ER"].includes(this.product.billing_period))
        if (this.product.no_billing) return "done";
        else return "activated";
      // unique
      else if (["EN", "WHO-EN"].includes(this.product.billing_period))
        if (this.product.no_billing) return "done";
        else return "progress";
      // active until
      else if (
        this.product.billing_end_date &&
        (this.$moment(this.now).isBefore(this.product.billing_end_date) ||
          this.$moment(this.now).isSame(this.product.billing_end_date))
      ) {
        return "active until {billing_end_date}";
        // terminated
      } else if (
        this.product.billing_end_date &&
        this.$moment(this.now).isAfter(this.product.billing_end_date)
      ) {
        return "terminated";
        // active
      } else {
        return "active";
      }
    },
    color() {
      if (this.status == "terminated" || this.status == "done")
        return "red darken-2 white--text my-1 mr-1";
      else if (this.status == "active until {billing_end_date}")
        return "amber darken-3 white--text my-1 mr-1";
      else return "green  white--text my-1 mr-1";
    },
    blocked() {
      return this.product.blocked;
    },
  },
};
</script>

<i18n>
{
  "en": {
    "terminated": "terminated",
    "active": "active",
    "active until {billing_end_date}": "active until {billing_end_date}",
    "prepared": "prepared",
    "blocked": "blocked",
    "activated": "activated",
    "done": "done",
    "progress": "progress"
  },
  "de": {
    "terminated": "gekündigt",
    "active": "aktiv",
    "active until {billing_end_date}": "aktiv bis {billing_end_date}",
    "prepared": "vorbereitet",
    "blocked": "blockiert",
    "activated": "aktiviert",
    "done": "abgeschlossen",
    "progress": "in Bearbeitung"
  }
}
</i18n>
